import React, { useContext, useState, useEffect } from "react";
import Button from "@mui/material/Button";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import { Dialog, Grid, Stack } from "@mui/material";
import { styled } from "@mui/material/styles";
import { Link } from "react-router-dom";
import pdfImage from "./images/prescription.jpg";
import res from "../../../resources";

const PrescriptionDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(4),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(3),
  },
  backdropFilter: "blur(5px)",
  backgroundColor: "rgba(255, 255, 255,0.1)",
}));

const PrescriptionModal = ({ show, handleClose }) => {
  return (
    <div>
      <PrescriptionDialog aria-labelledby="customized-dialog-title" open={show}>
        <DialogContent className="prescription-modal-content">
          <Grid item xs={12} md={12} lg={12}>
            <Stack direction="row" spacing={0} className="patientStack">
              <div className="prescription-modal-avatar">
                <img
                  alt="Patient Avatar"
                  src={res.Images.icons.prescriptionIcon.default}
                  width={"40px"}
                />
              </div>
              <div className="prescription-modal-heading">
                <h5>There is your prescription</h5>
                <p>This Prescription void in one month</p>
              </div>
            </Stack>
          </Grid>
          <img
            alt="tick icon"
            src={pdfImage}
            width={"100%"}
            height={"auto"}
          ></img>
        </DialogContent>
        <DialogActions className="deactivateDialogAction">
          {/* <Link to="/" className="paymentHistoryLink"> */}
          <Button
            variant="contained"
            className="prescription-modal-success-btn"
          >
            Continue
          </Button>
          {/* </Link> */}
          <Button
            variant="text"
            onClick={handleClose}
            className="prescription-modal-cancel-btn"
          >
            Cancel
          </Button>
        </DialogActions>
      </PrescriptionDialog>
    </div>
  );
};
export { PrescriptionModal };
